import React from 'react'
import { isEmpty } from 'lodash'

import { SCOPE_ALL, VIEW } from './AgenticInsights.constants'
import {
  getActionableInsights,
  getCompletedExperiments,
  getRunningExperiments,
  groupInsightsByScope,
  isLaunched,
} from './AgenticInsights.helpers'
import { ExperimentSpineCard } from './ExperimentSpineCard'
import { InsightSpineCard } from './InsightSpineCard'

const ExperimentCard = ({ insight, onOpen }) =>
  isLaunched(insight) ? (
    <ExperimentSpineCard insight={insight} onOpen={onOpen} />
  ) : (
    <InsightSpineCard insight={insight} onOpen={onOpen} />
  )

const Group = ({ label, insights, onOpen }) => {
  if (isEmpty(insights)) {
    return null
  }
  return (
    <>
      <div className="agentic-grouplabel">
        <span>{label}</span>
        <span className="agentic-grouplabel__line" />
      </div>
      {insights.map((insight) => (
        <ExperimentCard key={insight.id} insight={insight} onOpen={onOpen} />
      ))}
    </>
  )
}

// Experiments = Test. Anything ever started — running or completed — stays here
// across runs, since it outlives the run that proposed it. Proposals that were
// never started come from the newest run only; the page drops older runs'
// proposals before this renders.
export const ExperimentsTab = ({ scopeInsights, scope, playbooks, onOpen, onGoTo }) => {
  const running = getRunningExperiments(scopeInsights)
  const completed = getCompletedExperiments(scopeInsights)
  const proposed = getActionableInsights(scopeInsights)

  if (isEmpty(running) && isEmpty(completed) && isEmpty(proposed)) {
    return (
      <p className="agentic-muted">
        No experiments yet. When you launch an insight from the{' '}
        <button type="button" className="agentic-link-button" onClick={() => onGoTo(VIEW.INSIGHTS)}>
          Insights
        </button>{' '}
        tab, it shows up here so you can track whether it moves conversion.
      </p>
    )
  }

  if (scope === SCOPE_ALL) {
    const groups = groupInsightsByScope([...running, ...completed, ...proposed], playbooks)
    return (
      <div className="agentic-groups">
        {Object.entries(groups).map(([playbookName, groupInsights]) => (
          <section key={playbookName} className="agentic-group">
            <h3 className="agentic-group__head">{playbookName}</h3>
            {groupInsights.map((insight) => (
              <ExperimentCard key={insight.id} insight={insight} onOpen={onOpen} />
            ))}
          </section>
        ))}
      </div>
    )
  }

  return (
    <div className="agentic-stack">
      <Group label="Running" insights={running} onOpen={onOpen} />
      <Group label="Completed" insights={completed} onOpen={onOpen} />
      <Group label="Proposed" insights={proposed} onOpen={onOpen} />
    </div>
  )
}
